import React, { useEffect, useState } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import './SplashScreen.css';

function SplashScreen({ onClose }) {
  const { isDarkMode } = useTheme();
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // フェードインするためにタイマーを設定
    const fadeInTimer = setTimeout(() => {
      // フェードアウト効果を開始
      setFadeOut(true);
    }, 1000); // 1.5秒後にフェードアウト開始

    // 1.5秒後にコンポーネントを閉じる
    const closeTimer = setTimeout(() => {
      onClose();
    }, 1000);

    return () => {
      clearTimeout(fadeInTimer);
      clearTimeout(closeTimer);
    };
  }, [onClose]);

  return (
    <div className={`splash-screen ${fadeOut ? 'fade-out' : ''} ${isDarkMode ? 'dark' : 'light'}`}>
      <div className="splash-content">
        <img src="/images/logo.png" alt="DNS Logo" className="splash-logo" />
      </div>
    </div>
  );
}

export default SplashScreen; 